module.exports = __webpack_public_path__ + "static/img/logo3_en.242dc29d.png";